import { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';

const VideoContent = (props) => {
    const [url, setUrl] = useState([]);
    const [questionId, setQuestionId] = useState([]);
    const onClick = () => {
        window.location.href = "/admin/editquestiondetails/" + questionId + "/video";
    }
    useEffect(() => {
        setUrl(props.data['contentStr'])
        setQuestionId(JSON.parse(props.data.id));
    });

    return (
        <div>


            <div style={{ width: "30%", margin: "auto" }}>
                <div class="d-flex justify-content-center">
                    <div className='player-wrapper'>
                        {/* <video
                            width="640"
                            height="360"
                            controls
                            autoPlay={false}  // autoplay'i false yapıyoruz
                        >
                            <source src={url} type="video/mp4" />
                            Tarayıcınız video etiketini desteklemiyor.
                        </video> */}



                        <ReactPlayer
                            className='react-player'
                            url={url}
                            width='100%'
                            height="auto"

                            controls={true} />


                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-center'>
                <button className='btn btn-info' onClick={onClick}>Soruyu Düzenle</button>
            </div>
        </div>
    );
};

export default VideoContent;